import HangIcon from '../../assets/icons/vc-hang.svg?react';
import { MeetControl, MeetControlProps } from './MeetControl';

export function HangControl({ onClick, 'data-testid': dataTestId }: Readonly<MeetControlProps>) {
	return (
		<MeetControl color={'#DA322C'} onClick={onClick} data-testid={dataTestId}>
			<HangIcon fill={'#FFFFFF'} />
		</MeetControl>
	);
}
